const env = {
  clientID: "ddd-mgr",
  baseUrl: "https://tc-gateway.tuliu.com/ddd",
  permissionUrl: "https://tc-gateway.tuliu.com/permission",
  nongshiUrl: "https://tc-gateway.tuliu.com/nongshi",
  centerUrl: "https://tc-gateway.tuliu.com",
  clientSecret: "889DXfp23",
  OauthCId: "diduoduo",
  OauthCSecret: "45tl23x",
  ALIOSS: "https://tuliu-yzgj.oss-cn-hangzhou.aliyuncs.com/",
  TianDiTuKey: "ac65cdd406199a13db4231a79003403e",
  mode: "stage",
  WEBSSPortal: "https://wdlcnfzx.nongjiao.com", // 社会化门户
  WEBDIduoduo: "http://ncgj.nongjiao.com/admin", // 地多多
};

export default env;
